module.exports = __webpack_public_path__ + "static/img/tower.b470d492.png";